import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { GridRow, FullWidthSection, Heading2, withColor, withStyle, Section, Heading1, BiggerText, Text, SectionHeading, Link } from './MarketingStyles';

import { inject, observer } from 'mobx-react'
import config from 'react-global-configuration';

@inject('utilStore', 'translationStore')
@observer
class GolfCourseBenefitsSection extends Component {

  constructor(props) {
    super(props)
    this.state = {
      inview: []
    }
  }

  attachObserver = (elem, id) => {
    if(!this.intersectionTriggers)
      this.intersectionTriggers = []

    if(this.intersectionTriggers.includes(id)) return;

    if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
      this.setState({ inview: [id, ...this.state.inview] })
    }

    this.intersectionTriggers.push(id)

    const callbackFunc = (entries, observer) => {
      entries.forEach(entry => {
        if(!entry.isIntersecting) return
        observer.unobserve(entry.target)
        this.setState({ inview: [id, ...this.state.inview] })
      });
    }

    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3
    };

    let observer = new IntersectionObserver(callbackFunc, options);

    observer.observe(elem);
  }

  render() {

    const { golf_course_benefits } = this.props.utilStore.util

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <Section id="benefits">
        <GridRow
          desktop="2fr 3fr"
          tablet="100%"
          style={{ gridColumnGap: 100 }}
        >
          <div>
            <Heading1>{ text('marketing_gc_landingpage__benefits_title') }</Heading1>
            <BiggerText>{ text('marketing_gc_landingpage__benefits_subtitle') }</BiggerText>
            {/* <div ref={ ref => this.attachObserver(ref) }></div> */}
            <Text>{ text('marketing_gc_landingpage__benefits_text') }</Text>
            <div ref={ ref => this.attachObserver(ref, "benefits_list") }></div>
          </div>
          <CourseBenefitsList>
            { golf_course_benefits && golf_course_benefits.entries.map( (item, index) => (
              <div>
                <CourseBenefitsListItem visible={ this.state.inview.includes("benefits_list") } style={{ transitionDelay: ( index * 250 ) + "ms" }} isFirst={ index === 0 }>
                  <CourseBenefitsListItemNumber>{index + 1}.</CourseBenefitsListItemNumber>
                  <div>
                    <CourseBenefitsListItemHeading>{ item.title }</CourseBenefitsListItemHeading>
                    <GreyText>{ item.text }</GreyText>
                  </div>
                  <CourseBenefitsListItemIcon src={`${config.get('CLOUDINARY_URL')}${ item.icon } `} />
                </CourseBenefitsListItem>
              </div>
            ))}
          </CourseBenefitsList>
        </GridRow>
      </Section>
    )
  }
}

export default GolfCourseBenefitsSection

const GreyText = withColor(Text, cssVar.colors.grey)

const CourseBenefitsList = styled.div `
  width: 100%;

  ${cssVar.breakpoints.phone} {
    margin-top: 50px;
  }
`

const CourseBenefitsListItem = styled.div `
  display: grid;
  grid-template-columns: 1fr 6fr 100px 100px;
  border-bottom: 1px solid ${ cssVar.colors.gold };
  padding: 20px 0;
  margin-right: 0;
  transition: all ${ cssVar.transitions.basic };
  transition-duration: 750ms;

  ${ props => !props.visible && `
    transform: translateX(60vw);
  `}

  ${ props => props.isFirst && `
    border-top: 1px solid ${ cssVar.colors.gold };
  `}

  ${cssVar.breakpoints.phone} {
    grid-template-columns: 1fr;
    grid-template-areas: 'icon' 'content';
    text-align: center;

    ${ props => !props.visible && `
      transform: translateX(100vw);
    `}
  }
`

const CourseBenefitsListItemIcon = styled.img `
  grid-column: 4;
  height: 80px;
  width: 100%;
  object-fit: contain;

  ${cssVar.breakpoints.phone} {
    grid-area: icon;
  }
`

const CourseBenefitsListItemHeading = styled(Heading2) `
  padding-bottom: 10px;
`

const CourseBenefitsListItemNumber = styled(Heading2) `
  ${cssVar.breakpoints.phone} {
    display: none;
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/GolfCourseBenefitsSection.js